import { Box, Text, Flex, Image } from "@chakra-ui/react";

const ValueCard = ({ imgSrc, title, amount }) => {
  return (
    <Box
      bg="white"
      p="4"
      borderRadius="lg"
      boxShadow="md"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      w="full"
      minW="250px"
    >
      <Box>
        <Text
          fontSize="14px"
          fontFamily="PlusJakartaSansMedium"
          color="#456EFF80"
        >
          {title}
        </Text>
        <Text fontSize="24px" fontFamily="PlusJakartaSansBold" color="#456EFF">
        £{typeof amount === 'number' ? amount.toFixed(2) : amount}
        </Text>
      </Box>
      {/* <Image src={imgSrc} alt={title} boxSize="60px" objectFit="contain" /> */}
    </Box>
  );
};

export default ValueCard;
